import * as Const from "../config/const";
import * as Cookies from "react-cookies";

import React, { Component } from "react";

import Img from "react-image";
import { Link } from "react-router-dom";
//Images imports
import webfi from "../img/webfi.png";

export default class Footer extends Component {
  render() {
    return (
      <footer className=" w-100 justify-content-center align-items-center">
        <p>
          Rua Visconde de Carandaí, 28 - Jardim Botânico, Rio de Janeiro - CEP
          22460-020
        </p>
        <p>
          Copyright © 2020 - Todos os Direitos Reservados à{" "}
          <Link to={"//millenialsmafia.com"}>millenialsmafia.com</Link>{" "}
          <span className="d-none d-lg-inline-flex">|</span>{" "}
          <span className="d-block d-lg-inline-flex">
            {Cookies.load(Const.hash.cookie_lang) === "pt-br"
              ? "Feito por"
              : "Created by"}
            <a target={"_BLANK"} href={"//webfi.com.br/"}>
              <p>WEBFI</p>
            </a>
          </span>
        </p>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer.js